import { createContext, useContext, useState, useEffect } from "react";
import { decodeToken, isExpired } from "react-jwt";

import ConfirmModal from "../nps-components/common/ConfirmModal";
import { refreshTokenAPI } from "../services/authService";


const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    headerText: "Confirm Logout",
    bodyText: "Are you sure you want to log out?",
    bodySubText: "",
    btnConfirmText: "Confirm",
    btnCancelText: "Cancel",
  });

  const [user, setUser] = useState(() => {
    const savedUser = sessionStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [accessToken, setAccessToken] = useState(() => {
    return sessionStorage.getItem("accessToken") || null;
  });

  const [refreshToken, setRefreshToken] = useState(() => {
    return sessionStorage.getItem("refreshToken") || null;
  });

  const refreshAccessToken = async () => {
    try {
      const response = await refreshTokenAPI(refreshToken);

      const { accessToken: newAccessToken, refreshToken: newRefreshToken } = response.data;
      setAccessToken(newAccessToken);
      setRefreshToken(newRefreshToken);
      sessionStorage.setItem("accessToken", newAccessToken);
      sessionStorage.setItem("refreshToken", newRefreshToken);

      return newAccessToken;
    } catch (error) {
      console.error("Refresh failed:", error);
      logout();
    }
  };

  const login = (userData) => {
    
    const accessToken = userData.accessToken;
    const decodedToken = decodeToken(accessToken);
    if (!decodedToken) {
      console.error("Invalid JWT token");
      return;
    }

    const user = {      
      role: decodedToken.user_role,
      group: decodedToken.user_group,
      id: decodedToken.user_id,
      userName: decodedToken.user_name,
      lname: decodedToken.last_name,
      fname: decodedToken.first_name,
      email: decodedToken.email
    };

    // Check if this is the user's first login by checking if they have any stored preferences
    const isFirstLogin = !sessionStorage.getItem(`pushEnabled_${user.id}`) &&
      !sessionStorage.getItem(`user_${user.id}_has_logged_in`);


    setUser(user);
    setAccessToken(userData.accessToken);
    setRefreshToken(userData.refreshToken);
    
    console.log(user);
    
    sessionStorage.setItem("user", JSON.stringify(user));
    sessionStorage.setItem("accessToken", userData.accessToken);
    sessionStorage.setItem("refreshToken", userData.refreshToken);
    sessionStorage.setItem(`user_${user.id}_has_logged_in`, 'true');

    // Mark if this is a first login for push notification handling
    if (isFirstLogin) {
      sessionStorage.setItem(`user_${user.id}_first_login`, 'true');
    }
  };

  const logout = () => {
    setConfirmModal((prev) => ({ ...prev, isOpen: true }));
  };

  const confirmLogout = () => {
    setUser(null);
    setAccessToken(null);
    setRefreshToken(null);

    // Clear all session storage including push notification preferences
    sessionStorage.clear();

    setConfirmModal((prev) => ({ ...prev, isOpen: false }));
    window.location.href = '/nps-task/app/#/';
  };

  const cancelLogout = () => {
    setConfirmModal((prev) => ({ ...prev, isOpen: false }));
  };


  return (
    <AuthContext.Provider value={{ user, accessToken, refreshToken, login, logout, refreshAccessToken }}>
      {children}
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        onConfirm={confirmLogout}
        onCancel={cancelLogout}
        headerText={confirmModal.headerText}
        bodyText={confirmModal.bodyText}
        bodySubText={confirmModal.bodySubText}
        btnConfirmText={confirmModal.btnConfirmText}
        btnCancelText={confirmModal.btnCancelText}
      />
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
